<template>
    <MobileTopBar :with_logo="true"/>
    <div class="container">
        <div class="md:mb-10">
            <HomeSlider/>
        </div>
        <div class="mb-5 md:mb-10">
            <ProductCategoriesLinks :categories="categories"/>
        </div>
        <div v-if="!themeStore.minimize_ui" class="mb-5 md:mb-10">
            <HomeAboutBlock/>
        </div>
    </div>
    <div v-if="!themeStore.minimize_ui" class="md:container max-md:ms-5 mb-5 md:mb-10">
        <PopularProducts/>
    </div>
    <div v-if="!themeStore.minimize_ui" class="container">
        <ManagersSection/>
    </div>
    <div v-if="!themeStore.minimize_ui" class="container">
        <FaqComponent title="Частые вопросы о металлопрокате"
                      subtitle="Ассортимент, резка, ГОСТ и марки стали, расчёт веса и логистика."
                      :items="homeFaqItems"
                      schema-id="schema-home-faq-jsonld"/>
    </div>
    <FastBuyCallback v-if="!themeStore.minimize_ui"/>
</template>

<script>
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import HomeSlider from "@js/components/Sections/PageComponent/Home/HomeSlider.vue";
import ProductCategoriesLinks from "@js/components/Sections/PageComponent/Home/ProductCategoriesLinks.vue";
import HomeAboutBlock from "@js/components/Sections/PageComponent/Home/HomeAboutBlock.vue";
import PopularProducts from "@js/components/Sections/Sliders/PopularProducts.vue";
import FaqComponent from "@js/components/Faq/FaqComponent.vue";
import FastBuyCallback from "@js/components/Callbacks/FastBuyCallback.vue";
import {useThemeStore} from "@js/store/ThemeStore.js";
import ManagersSection from "@js/components/Sections/About/ManagersSection.vue";

export default {
    name: 'Home',
    props: {
        categories: {
            required: true,
        }
    },
    components: {
        ManagersSection,
        FastBuyCallback,
        FaqComponent,
        PopularProducts,
        HomeAboutBlock,
        ProductCategoriesLinks,
        HomeSlider,
        MobileTopBar,
        OnlyDesktop,
    },
    data() {
        return {
            homeFaqItems: [
                {
                    question: 'Можно оплатить товар по факту доставки, чтобы не ехать в офис?',
                    answer: `
      <p>Да, возможна оплата <strong>по факту доставки металлопроката</strong> на объект/склад получателя.
      Заказ подтверждаем дистанционно (телефон/мессенджер/почта), выставляем счёт-оферту, резервируем товар на складе.</p>
      <p class="mt-2">Для запуска логистики требуется <strong>предоплата за доставку</strong>.
      При индивидуальной металлообработке (резка в размер, раскрой листа) необходима <strong>предоплата 30%</strong> от суммы заказа.
      Предоплата возможна безналом, переводом через мобильное приложение банка.</p>
      <p class="mt-2">Оплату по факту фиксируем в документах отгрузки; предоставляем закрывающие документы по запросу.</p>
    `
                },
                {
                    question: 'Возможно ли доставка в нерабочее время и выходные дни?',
                    answer: `
      <p>Да. Организуем <strong>доставку металлопроката ночью и в выходные</strong> по согласованному окну.
      Это удобно для срочных строек, монтажа и объектов с дневными ограничениями.</p>
      <p class="mt-2">Подбираем транспорт под номенклатуру: длинномер (арматура, двутавр, швеллер), бортовая/тент,
      при необходимости — <strong>манипулятор</strong> для адресной разгрузки.
      Сроки и стоимость рассчитываем индивидуально по адресу и объёму.</p>
    `
                },
                {
                    question: 'Входит ли разгрузка в стоимость доставки?',
                    answer: `
      <p>Базовая услуга — это <strong>транспортировка до точки выгрузки</strong>.
      Разгрузка силами покупателя: подготовьте площадку, подъезд и бригаду.</p>
      <p class="mt-2">По запросу доступны <strong>дополнительные услуги</strong>: манипулятор, такелаж,
      подача краном, рокля/тележка и др. Стоимость зависит от сложности, номенклатуры и времени простоя.</p>
    `
                },
                {
                    question: 'Как происходит процесс взвешивания металла?',
                    answer: `
      <p>Отгрузка сопровождается <strong>весовым контролем</strong> на поверенных электронных весах.
      Фиксируем <em>фактическую массу</em> и выдаём талон/отметку в документах.</p>
      <p class="mt-2">Для сортамента допустимо расхождение между <em>теоретическим весом по ГОСТ</em> и фактическим.
      В спорных случаях предоставим фото/видео фиксацию и пересчёт. Итог к оплате — по факту комплектации и взвешивания.</p>
    `
                },
                {
                    question: 'Цены на сайте для физических и юридических лиц одинаковые?',
                    answer: `
      <p>Опубликованные цены носят розничный характер и ориентированы на физические лица.
      Для <strong>юридических лиц (ООО/ИП)</strong> формируем коммерческое предложение с учётом <strong>НДС</strong>,
      объёма, номенклатуры и условий поставки.</p>
      <p class="mt-2">Доступны оптовые прайс-листы, фиксирование цены счётом-офертой на срок, а также долгосрочные
       условия для регулярных закупок. Укажите тип покупателя при оформлении заказа — подготовим индивидуальные условия.</p>
    `
                }
            ]
        };
    },
    beforeMount() {
    },
    setup() {
        const themeStore = useThemeStore();
        return {themeStore}
    },
    mounted() {
        this.isMounted = true
    }
};
</script>

<style lang="scss">

</style>
